module.exports = __webpack_public_path__ + "static/media/hoursLogged.a99d74a2.svg";